import { useTranslation } from '@dukanti/shared';

export function EntitlementUsageMeter(props: {
  readonly label: string;
  readonly used: number;
  readonly limit: number;
  readonly valueLabel: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const hasCapacity = props.limit > 0;
  const percentage = hasCapacity ? Math.min(100, (props.used / props.limit) * 100) : 0;

  return (
    <div className="rounded-card border-sand-200 bg-paper border p-4 text-start shadow-sm">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sand-700 text-sm font-medium">{props.label}</p>
        <p className="text-sand-500 text-xs" dir="ltr">
          {props.valueLabel}
        </p>
      </div>
      <div
        className="bg-sand-100 mt-3 h-2 overflow-hidden rounded-full"
        role="meter"
        aria-label={props.label}
        aria-valuemin={0}
        aria-valuemax={hasCapacity ? props.limit : 1}
        aria-valuenow={hasCapacity ? Math.min(props.used, props.limit) : 0}
      >
        <div className="bg-zaatar h-full rounded-full" style={{ width: `${percentage}%` }} />
      </div>
      {!hasCapacity ? (
        <p className="text-sand-500 mt-2 text-xs">{t('admin.billing.usage.noLimit')}</p>
      ) : null}
    </div>
  );
}
